import React from "react";

import Banner from "../components/Banner";
import ProductGrid from "../components/CartSystem";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import landingAsset from "../utils/assetPaths";

const Shop: React.FC = () => {
    return (
        <>
            <Navbar />
            <div
                style={{
                    backgroundImage: `url(${landingAsset("herobg.svg")})`,
                    backgroundSize: "cover",
                }}
                className="h-[500px] md:h-[400px] relative w-full flex justify-center items-center flex-col "
            >
                <div
                    style={{
                        background:
                            "linear-gradient(180deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 17.83%)",
                    }}
                    className=" h-full w-full absolute left-0 top-0"
                >
                    <div className=" w-full h-full flex flex-col items-center text-center justify-center p-4">
                        <h1 className="text-white text-4xl md:text-5xl lg:text-6xl font-black font-Manrope uppercase tracking-tight">SACA Shop</h1>
                        <p className="mt-6 text-center font-Manrope text-lg md:text-xl text-white/90 max-w-3xl leading-relaxed">
                            Discover exclusive football gear, apparel, and accessories. Shop
                            now and represent the game in style with premium SACA merchandise.
                        </p>
                    </div>
                </div>
            </div>
            <div className=" flex flex-col items-center py-20 w-full px-4 md:px-14 bg-white">
                <div className="max-w-7xl mx-auto w-full">
                    <ProductGrid where={"landing"} />
                </div>
            </div>
            <Banner />
            <Footer />
        </>
    );
};

export default Shop;
